import React from "react";
// import BannerSectionStyle7 from '../Section/BannerSection/BannerSectionStyle7';
import Section from "../Section";
// import AppointmentSection from '../Section/AppointmentSection';
// import BreadcrumbStyle2 from '../Breadcrumb/BreadcrumbStyle2';
// import AboutSectionStyle2 from '../Section/AboutSection/AboutSectionStyle2';
// import FeaturesSectionStyle3 from '../Section/FeaturesSection/FeaturesSectionStyle3';
import TeamSectionStyle3 from "../Section/TeamSection/TeamSectionStyle3";
import { pageTitle } from "../../helpers/PageTitle";
// import Breadcrumb from '../Breadcrumb';
// import WorkingProcess from '../Section/WorkingProcess';
import BannerSectionStyle2 from "../Section/BannerSection/BannerSectionStyle2";
import FaqSectionStyle3 from "../Section/FaqSection/FaqSectionStyle3";
import DoctorDetailsSection from "../Section/DoctorDetailsSection";
import ProductsDetailMainSection from "./ProductsDetailMainSection";
import { ProductFeaturesDetails } from "./ProductFeaturesDetails";
import { Specification } from "./Specification";
import { Options } from "./Options";
import { Helmet } from "react-helmet";




const featureDataList = [
  {
    tittle: "Hyper Hypo Therima Unit",
    srtrongtitle: [
      "Fastest Heating & Cooling in its Class",
      "Graphical User Interface",
      "Fully Touch Controller Display",
      "Diagnostic Mode",
      "Emergency Manual Mode",
      "Custom Configuration",
      "Auto-Cleaning Mode",
      "Independent Operation",
      "The Unit Offers Two Options"

    ],
    feature: [
      "It has separate cooling tank and heating chambers to achieve desired set point quickly.",
      " Visual & easy to use graphical interface for water flow, heating & cooling temperature, water level indicator.",
      "All parameter can be controlled on finger touch.",
      "Introducing first ever diagnostic mode for troubleshooting remotely. ",
      "In case of emergency Manual mode with interactive colorful keys.",
      "HHU can be configurable according to customer's requirement.",
      "Auto cleaning mode for descaling and disinfecting the unit.",
      "Independent heating and cooling for Cardiopledgia and patient circuits.",
      "One without a wireless remote and one with a wireless remote having a 10-meter range."

    ],
    images: [
      "images/detailspageimages/19.png",
      "images/detailspageimages/18.png",
      "images/detailspageimages/17.png",
      "images/detailspageimages/20.png",
      "images/detailspageimages/21.png",

    ],
    SideImages: [
      "images/detailspageimages/22.png",
      "images/detailspageimages/23.png",
      "images/detailspageimages/24.png",
    ]
  }
]
// Assuming Specifications is imported or defined above this component
const Specifications = [
  {
    title: "Hyper-Hypothemia units",
    subheading: "Specifications",
    DimensionsTitle: "Dimensions",
    PowerSupplyTitle: "Power Supply",
    CompressorTitle: "Compressor",
    OutputPortsTitle: "Output Ports",
    CoolingWaterTankTitle: "Cooling Water Tank",
    HeatingChamberTitle: "Heating Chamber",
    AutoCleaningTitle: "Auto Cleaning",
    TemperatureRangeTitle: "Temperature Range",
    Dimensions: [
      'Height: 35.1" (89.2 cm)',
      'Width: 20.7" (52.3 cm)',
      'Depth: 24.5" (62.2 cm)',
      'Weight: 247 lbs. (112kg)',
    ],
    PowerSupply: [
      "Voltage: 220 VAC, 1 Phase",
      "Frequency: 50Hz",
      "Current: 25A",
      "Leakage Current: 500mA max",
    ],
    Compressor: ["Capacity: 1.5 Ton"],
    OutputPorts: [
      "Patient/Oxygenator: Quick Connect, 10 Ltr/min",
      "Patient/Blanket: Quick Connect, 2 Ltr/min",
      "Cardioplegia: Quick Connect, 10 Ltr/min",
    ],
    CoolingWaterTank: [
      "Capacity: 23 Liter (6.1 Gal), Single tank",
      "Size: 27 x 29.5 x 34.5 CMs",
    ],
    HeatingChamber: [
      "Patient Chamber: 1 Liter",
      "Patient Heater Wattage: 2000 Watt",
      "Cardioplegia Chamber: 1 Liter",
      "Cardioplegia Heater Wattage: 1000 Watt",
    ],
    AutoCleaning: [
      "Maximum Temperature: 70°C (158°F)",
      "Cleaning & Disinfection Time: 3 Hrs.",
    ],
    TemperatureRange: ["Output Water Temp Range: 3-42°C (37-107°F)"],
  },
];
const Applications = [{

  "applicationsTitle": "Applications",
  "description": {
    "text": "The Mercury Hyper-Hypothermia Unit can be used for surgeries like:",
    "style": {
      "color": "#274760"
    }
  },
  "applicationList": [
    "Arterial/ventricular Septal Defects",
    "CABG (Coronary Artery Bypass Grafting)",
    "Heart valve replacement (MVR, AVR & PVR)",
    "Congenital Surgeries",
    "Hypothermic Surgeries"
  ]


}]



export default function HyperHypothermiaUnit() {
  pageTitle("Department Details");
  return (
    <>
      <Helmet>
        <title>Hyper-Hypothermia Unit - Mercuryhc | Manufacturer and Exporters in India.

        </title>

        <meta name="Keyword" content="Hyper-Hypothermia Unit,
Hyper-Hypothermia Machine,
Temperature Management System,
Patient Warming and Cooling Unit,
Hypothermia Treatment Device,
Medical Temperature Control Unit,
Therapeutic Hypothermia Equipment,
Hyperthermia Therapy Unit,
Temperature Regulation in Surgery,
Body Temperature Management System,
Perioperative Temperature Management,
Hypothermia Prevention Equipment,
Cardiac Surgery Cooling System,
ICU Temperature Control Device,
Hyper-Hypothermia Unit Manufacturer India,
Medical Cooling and Warming System Exporter,
Hyper-Hypothermia Equipment Supplier India,
Patient Temperature Control Solutions,
Advanced Hyper-Hypothermia Devices,
Hyper-Hypothermia Unit for Hospitals," />
        <meta name="description" content="Mercury Hyper-Hypothermia Unit ensures precise blood temperature control for surgeries. Features touch display, auto-cleaning, and independent heating & cooling." />
        {/* Google Tag (gtag.js) */}
        <script async src="https://www.googletagmanager.com/gtag/js?id=G-MGF4V7P4YB"></script>
        <script>
          {`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-MGF4V7P4YB');
      `}
        </script>

      </Helmet>
      {/* <BreadcrumbStyle2 />
      <Section topMd={135} topLg={100} topXl={100}>
        <AboutSectionStyle2
          title="Hyper & Hypothermia Unit"
          subTitle="Advanced unit for precise temperature control, ensuring optimal patient care."
          imgUrl="/images/departments/department_img_1.png"
        />
      </Section> */}
      {/* <Section topMd={170} bottomMd={54} bottomLg={54}>
        <Breadcrumb title="Hyper & Hypothermia Unit" />
      </Section>
      <div className="container">
        <img
          src="/images/blog/blog_details_1.jpeg"
          alt="Blog Details"
          className="w-100 cs_radius_20"
        />
      </div> */}
      {/* <Section topMd={170}   bottomLg={54}>
        <BannerSectionStyle2
          bgUrl="/images/home_2/hyperbg.png"
          title="Hyper & Hypothermia Unit"
          subTitle="Advanced unit for precise temperature control, ensuring optimal patient care."
        />
      </Section> */}
      {/* <Section
        topMd={185}
        topLg={140}
        topXl={100}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <WorkingProcess
          sectionTitle="Features"
          sectionTitleUp=""
          sectionTitleDown=""
          sectionSubTitle=""
          data={featureData}
        />
      </Section> */}
      <Section   >
        {/* <DoctorDetailsSection


          imgUrl="/images/departments/Hyper-Hypothermia Unit.jpg"
          name="Hyper & Hypothermia Unit"
          department="Hyper & Hypothermia Unit"

          description="Mercury Hyper-Hypothermia machine also known as Heater-Cooler Machine, providing the functionality of maintaining the blood temperature of patient during the surgeries. HHU is used to lower/ raise/ maintain the blood temperature through conductive heat transfer with the help of oxygenator/heat exchanger, along with the use of a blanket under the patient for rewarming phase if needed. The user regulates the desired fluid temperature with continuous monitoring. Mercury also features a separate cardiopledgia circuit to maintain cardiopledgia temperature."
        /> */}

        <ProductsDetailMainSection
          imgUrl="/images/departments/Hyper-Hypothermia Unit.jpg"
          Applications={Applications}
          name="Hyper & Hypothermia Unit 1 (Patent applied for)"
          department="Hyper & Hypothermia Unit 1"
          description="Mercury Hyper-Hypothermia machine (Patent applied for) also known as Heater-Cooler Machine, providing the functionality of maintaining the blood temperature of patient during the surgeries. HHU is used to lower/ raise/ maintain the blood temperature through conductive heat transfer with the help of oxygenator/heat exchanger, along with the use of a blanket under the patient for rewarming phase if needed. The user regulates the desired fluid temperature with continuous monitoring. Mercury also features a separate cardiopledgia circuit to maintain cardiopledgia temperature."

        />
      </Section>

      <Section  >
        {/* <FaqSectionStyle3
          data={featureData}
          sectionTitle="Features"
          sectionTitleUp=" "
          sectionTitleDown=""
          sectionSubTitle=""
        /> */}
        <ProductFeaturesDetails data={featureDataList} />
      </Section>
      {/* <Section  >
        <FaqSectionStyle3
          data={featureData}
          sectionTitle="Features"
          sectionTitleUp=" "
          sectionTitleDown=""
          sectionSubTitle=""
        />
        <Options  />
      </Section> */}

      <Section topMd={170} topLg={145} topXl={90} bottomLg={90}>
        <Specification
          sectionTitle="Specifications"

          Specifications={Specifications}
        />
      </Section>

      {/* <Section topMd={170} topLg={145} topXl={90}>
        <FeaturesSectionStyle3
          sectionTitle="Features"
          sectionTitleUp="MORE TYPE OF"
          data={featureData}
        />
      </Section> */}
      {/* <Section topMd={200} topLg={150} topXl={100}>
        <TeamSectionStyle3 sectionTitle="Related Products" data={doctorData} />
      </Section> */}

      {/* Start Appointment Section */}
      {/* <Section
        topMd={190}
        topLg={145}
        topXl={105}
        bottomMd={190}
        bottomLg={145}
        bottomXl={110}
        id="appointment"
      >
        <AppointmentSection
          sectionTitle="Appointment"
          sectionTitleUp="BOOK AN"
          imgUrl="/images/home_1/appointment.jpeg"
        />
      </Section> */}
      {/* End Appointment Section */}
      {/* <Section className="cs_footer_margin_0" topMd={190} topLg={145} topXl={105}>
        <BannerSectionStyle7
          imgUrl="/images/departments/banner_img_3.png"
          bgUrl="/images/departments/banner_bg_3.svg"
          title="Don’t Let Your Health <br />Take a Backseat!"
          subTitle="Schedule an appointment with one of our experienced <br />medical professionals today!"
        />
      </Section> */}
    </>
  );
}
